module.exports = __webpack_public_path__ + "img/ques-60.86d1a77f.png";